import { Navigate } from "react-router";

export default function ProtectedRoute({ visible, children }) {
  if (!visible) {
    return <Navigate to="/" replace />;
  }

  return children;
}
